// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Google Font ─────────────────────────────────────────── */

/* ── page wrapper ────────────────────────────────────────── */
.sl-page {
  height: 100vh;
  width: 100vw;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 16px;
  gap: 16px;
  box-sizing: border-box;
  font-family: "Inter", "Segoe UI", sans-serif;
}

@media (min-width: 1024px) {
  .sl-page { padding: 20px; gap: 20px; }
}

/* ── header card (standalone) ────────────────────────────── */
.sl-header-card {
  background: #ffffff;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
  flex-shrink: 0;
}

/* ── header ──────────────────────────────────────────────── */
.sl-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
}

@media (min-width: 1024px) {
  .sl-header { padding: 12px 32px; }
}

.sl-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.sl-logo {
  height: 28px;
  width: auto;
  object-fit: contain;
}

@media (min-width: 1024px) {
  .sl-logo { height: 32px; }
}

.sl-step-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 9999px;
  border: 1px solid #dbeafe;
  background: #eff6ff;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #2a71ff;
}

/* ── body ────────────────────────────────────────────────── */
.sl-body {
  flex: 1;
  min-height: 0;
  padding: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

@media (min-width: 1024px) {
  .sl-body { padding: 20px; }
}

/* ── two-column wrapper ──────────────────────────────────── */
.sl-two-col {
  display: flex;
  gap: 16px;
  flex: 1;
  min-height: 0;
}

/* ── shared panel ────────────────────────────────────────── */
.sl-panel {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 26px;
  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.06);
  overflow: hidden;
  min-height: 0;
}

.sl-panel-org {
  width: 38%;
  flex-shrink: 0;
}

.sl-panel-loc {
  flex: 1;
  min-width: 0;
}

/* ── panel header ────────────────────────────────────────── */
.sl-panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px 12px;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
}

.sl-section-tag {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #2a71ff;
  margin: 0 0 4px 0;
}

.sl-section-title {
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #020617;
  margin: 0;
}

@media (min-width: 1280px) {
  .sl-section-title { font-size: 1.25rem; }
}

.sl-choose-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #94a3b8;
  padding-top: 4px;
  flex-shrink: 0;
}

.sl-org-badge {
  font-size: 12px;
  font-weight: 700;
  color: #15803d;
  background: rgba(236, 253, 245, 0.7);
  border: 1px solid #d1fae5;
  border-radius: 9999px;
  padding: 4px 12px;
  flex-shrink: 0;
  white-space: nowrap;
}

/* ── search bar ──────────────────────────────────────────── */
.sl-search-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 16px 8px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  background: #f8fafc;
  transition: border-color 0.15s, box-shadow 0.15s;
  flex-shrink: 0;
}

.sl-search-wrap:focus-within {
  border-color: #2a71ff;
  box-shadow: 0 0 0 3px rgba(42, 113, 255, 0.1);
  background: #fff;
}

.sl-search-wrap.sl-search-disabled {
  opacity: 0.45;
  pointer-events: none;
}

.sl-search-icon {
  flex-shrink: 0;
}

.sl-search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  color: #334155;
  font-family: inherit;
  min-width: 0;
}

.sl-search-input::placeholder { color: #94a3b8; }

.sl-search-input:disabled { cursor: not-allowed; }

.sl-search-clear {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #94a3b8;
  font-size: 11px;
  line-height: 1;
  flex-shrink: 0;
  transition: color 0.15s;
}

.sl-search-clear:hover { color: #475569; }

/* ── scrollable list area ────────────────────────────────── */
.sl-panel-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 6px 12px 12px;
  scrollbar-width: thin;
  scrollbar-color: #e2e8f0 transparent;
}

.sl-panel-list::-webkit-scrollbar { width: 4px; }
.sl-panel-list::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 4px; }

/* ── org row ─────────────────────────────────────────────── */
.sl-org-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 18px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background 0.12s, border-color 0.12s, box-shadow 0.12s;
  margin-bottom: 4px;
  background: #fff;
}

.sl-org-row:hover {
  background: #f8fafc;
  border-color: #e2e8f0;
}

.sl-org-row.selectedb {
  border-color: #2a71ff;
  background: linear-gradient(135deg, #eff6ff 0%, #ffffff 100%);
  box-shadow: 0 4px 16px rgba(42, 113, 255, 0.12);
}

.sl-org-row.sl-kb-focused {
  outline: 2px solid #2a71ff;
  outline-offset: 2px;
}

.sl-org-row-text {
  flex: 1;
  min-width: 0;
}

.sl-avatar {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 900;
  flex-shrink: 0;
}

.sl-org-name {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #020617;
  margin: 0 0 2px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sl-org-desc {
  font-size: 12px;
  color: #64748b;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sl-org-count-pill {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #94a3b8;
  background: #f1f5f9;
  border-radius: 9999px;
  padding: 3px 8px;
  white-space: nowrap;
  flex-shrink: 0;
}

.sl-org-row.selectedb .sl-org-count-pill {
  background: #dbeafe;
  color: #2a71ff;
}

/* ── check icon ──────────────────────────────────────────── */
.sl-check-icon {
  width: 22px;
  height: 22px;
  background: #2a71ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
}

.sl-check-icon svg { width: 12px; height: 12px; }

/* ── location row ────────────────────────────────────────── */
.sl-loc-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 18px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.12s, box-shadow 0.12s, background 0.12s;
  margin-bottom: 6px;
}

.sl-loc-row:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.sl-loc-row.sl-kb-focused {
  outline: 2px solid #2a71ff;
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(42, 113, 255, 0.15);
}

.sl-loc-row-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.sl-loc-pin-wrap {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: #eff6ff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sl-loc-name {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #020617;
  margin: 0 0 2px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sl-loc-state {
  font-size: 12px;
  color: #64748b;
  margin: 0;
}

/* ── status badge ────────────────────────────────────────── */
.sl-status-badge {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  padding: 4px 10px;
  border-radius: 9999px;
  flex-shrink: 0;
}

.sl-status-badge.active { background: #f0fdf4; color: #15803d; }
.sl-status-badge.ready  { background: #eff6ff; color: #2a71ff; }

/* ── empty states ────────────────────────────────────────── */
.sl-empty-msg {
  font-size: 13px;
  color: #94a3b8;
  text-align: center;
  padding: 24px 0;
  margin: 0;
}

.sl-loc-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 100%;
  min-height: 200px;
  text-align: center;
  padding: 32px;
}

.sl-loc-empty-icon {
  width: 64px;
  height: 64px;
  border-radius: 20px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sl-loc-empty-title {
  font-size: 15px;
  font-weight: 700;
  color: #334155;
  margin: 0;
}

.sl-loc-empty-sub {
  font-size: 13px;
  color: #94a3b8;
  max-width: 280px;
  margin: 0;
  line-height: 1.5;
}

/* ── loading ─────────────────────────────────────────────── */
.sl-loading {
  display: flex;
  justify-content: center;
  padding: 40px 0;
}

/* ── back btn (kept for safety) ──────────────────────────── */
.sl-back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #64748b;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  flex-shrink: 0;
}

.sl-back-btn:hover { background: #f8fafc; color: #0f172a; }

/* ── responsive ──────────────────────────────────────────── */
@media (max-width: 700px) {
  .sl-page { padding: 0; }
  .sl-card { border-radius: 0; border: none; }
  .sl-two-col { flex-direction: column; overflow-y: auto; }
  .sl-panel-org { width: 100%; flex-shrink: 0; max-height: 45vh; }
  .sl-panel-loc { flex: none; min-height: 40vh; }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/LocationModal/indexV2.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAG/D,+DAA+D;AAC/D;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,WAAW,aAAa,EAAE,SAAS,EAAE;AACvC;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa,kBAAkB,EAAE;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW,YAAY,EAAE;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW,aAAa,EAAE;AAC5B;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,SAAS;EACT,OAAO;EACP,aAAa;AACf;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oBAAoB,kBAAkB,EAAE;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,YAAY;AACd;;AAEA,gCAAgC,cAAc,EAAE;;AAEhD,4BAA4B,mBAAmB,EAAE;;AAEjD;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;;AAEA,yBAAyB,cAAc,EAAE;;AAEzC,+DAA+D;AAC/D;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,oCAAoC,UAAU,EAAE;AAChD,0CAA0C,mBAAmB,EAAE,kBAAkB,EAAE;;AAEnF,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,kEAAkE;EAClE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA,qBAAqB,WAAW,EAAE,YAAY,EAAE;;AAEhD,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,kEAAkE;EAClE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;;AAE/D,+DAA+D;AAC/D;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,cAAc;AAChB;;AAEA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D,+DAA+D;AAC/D;EACE,WAAW,UAAU,EAAE;EACvB,WAAW,gBAAgB,EAAE,YAAY,EAAE;EAC3C,cAAc,sBAAsB,EAAE,gBAAgB,EAAE;EACxD,gBAAgB,WAAW,EAAE,cAAc,EAAE,gBAAgB,EAAE;EAC/D,gBAAgB,UAAU,EAAE,gBAAgB,EAAE;AAChD","sourcesContent":["/* ── Google Font ─────────────────────────────────────────── */\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap\");\n\n/* ── page wrapper ────────────────────────────────────────── */\n.sl-page {\n  height: 100vh;\n  width: 100vw;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  padding: 16px;\n  gap: 16px;\n  box-sizing: border-box;\n  font-family: \"Inter\", \"Segoe UI\", sans-serif;\n}\n\n@media (min-width: 1024px) {\n  .sl-page { padding: 20px; gap: 20px; }\n}\n\n/* ── header card (standalone) ────────────────────────────── */\n.sl-header-card {\n  background: #ffffff;\n  border-radius: 24px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);\n  flex-shrink: 0;\n}\n\n/* ── header ──────────────────────────────────────────────── */\n.sl-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 24px;\n}\n\n@media (min-width: 1024px) {\n  .sl-header { padding: 12px 32px; }\n}\n\n.sl-header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.sl-logo {\n  height: 28px;\n  width: auto;\n  object-fit: contain;\n}\n\n@media (min-width: 1024px) {\n  .sl-logo { height: 32px; }\n}\n\n.sl-step-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 9999px;\n  border: 1px solid #dbeafe;\n  background: #eff6ff;\n  padding: 4px 12px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #2a71ff;\n}\n\n/* ── body ────────────────────────────────────────────────── */\n.sl-body {\n  flex: 1;\n  min-height: 0;\n  padding: 16px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n@media (min-width: 1024px) {\n  .sl-body { padding: 20px; }\n}\n\n/* ── two-column wrapper ──────────────────────────────────── */\n.sl-two-col {\n  display: flex;\n  gap: 16px;\n  flex: 1;\n  min-height: 0;\n}\n\n/* ── shared panel ────────────────────────────────────────── */\n.sl-panel {\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 26px;\n  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.06);\n  overflow: hidden;\n  min-height: 0;\n}\n\n.sl-panel-org {\n  width: 38%;\n  flex-shrink: 0;\n}\n\n.sl-panel-loc {\n  flex: 1;\n  min-width: 0;\n}\n\n/* ── panel header ────────────────────────────────────────── */\n.sl-panel-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 18px 20px 12px;\n  border-bottom: 1px solid #f1f5f9;\n  flex-shrink: 0;\n}\n\n.sl-section-tag {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: #2a71ff;\n  margin: 0 0 4px 0;\n}\n\n.sl-section-title {\n  font-size: 1.1rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #020617;\n  margin: 0;\n}\n\n@media (min-width: 1280px) {\n  .sl-section-title { font-size: 1.25rem; }\n}\n\n.sl-choose-label {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  padding-top: 4px;\n  flex-shrink: 0;\n}\n\n.sl-org-badge {\n  font-size: 12px;\n  font-weight: 700;\n  color: #15803d;\n  background: rgba(236, 253, 245, 0.7);\n  border: 1px solid #d1fae5;\n  border-radius: 9999px;\n  padding: 4px 12px;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n/* ── search bar ──────────────────────────────────────────── */\n.sl-search-wrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 10px 16px 8px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 9999px;\n  background: #f8fafc;\n  transition: border-color 0.15s, box-shadow 0.15s;\n  flex-shrink: 0;\n}\n\n.sl-search-wrap:focus-within {\n  border-color: #2a71ff;\n  box-shadow: 0 0 0 3px rgba(42, 113, 255, 0.1);\n  background: #fff;\n}\n\n.sl-search-wrap.sl-search-disabled {\n  opacity: 0.45;\n  pointer-events: none;\n}\n\n.sl-search-icon {\n  flex-shrink: 0;\n}\n\n.sl-search-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 13px;\n  color: #334155;\n  font-family: inherit;\n  min-width: 0;\n}\n\n.sl-search-input::placeholder { color: #94a3b8; }\n\n.sl-search-input:disabled { cursor: not-allowed; }\n\n.sl-search-clear {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: #94a3b8;\n  font-size: 11px;\n  line-height: 1;\n  flex-shrink: 0;\n  transition: color 0.15s;\n}\n\n.sl-search-clear:hover { color: #475569; }\n\n/* ── scrollable list area ────────────────────────────────── */\n.sl-panel-list {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 6px 12px 12px;\n  scrollbar-width: thin;\n  scrollbar-color: #e2e8f0 transparent;\n}\n\n.sl-panel-list::-webkit-scrollbar { width: 4px; }\n.sl-panel-list::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 4px; }\n\n/* ── org row ─────────────────────────────────────────────── */\n.sl-org-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 18px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: background 0.12s, border-color 0.12s, box-shadow 0.12s;\n  margin-bottom: 4px;\n  background: #fff;\n}\n\n.sl-org-row:hover {\n  background: #f8fafc;\n  border-color: #e2e8f0;\n}\n\n.sl-org-row.selectedb {\n  border-color: #2a71ff;\n  background: linear-gradient(135deg, #eff6ff 0%, #ffffff 100%);\n  box-shadow: 0 4px 16px rgba(42, 113, 255, 0.12);\n}\n\n.sl-org-row.sl-kb-focused {\n  outline: 2px solid #2a71ff;\n  outline-offset: 2px;\n}\n\n.sl-org-row-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.sl-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 900;\n  flex-shrink: 0;\n}\n\n.sl-org-name {\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: #020617;\n  margin: 0 0 2px 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sl-org-desc {\n  font-size: 12px;\n  color: #64748b;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sl-org-count-pill {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  background: #f1f5f9;\n  border-radius: 9999px;\n  padding: 3px 8px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.sl-org-row.selectedb .sl-org-count-pill {\n  background: #dbeafe;\n  color: #2a71ff;\n}\n\n/* ── check icon ──────────────────────────────────────────── */\n.sl-check-icon {\n  width: 22px;\n  height: 22px;\n  background: #2a71ff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.sl-check-icon svg { width: 12px; height: 12px; }\n\n/* ── location row ────────────────────────────────────────── */\n.sl-loc-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: 18px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  cursor: pointer;\n  transition: border-color 0.12s, box-shadow 0.12s, background 0.12s;\n  margin-bottom: 6px;\n}\n\n.sl-loc-row:hover {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);\n}\n\n.sl-loc-row.sl-kb-focused {\n  outline: 2px solid #2a71ff;\n  outline-offset: 2px;\n  box-shadow: 0 0 0 4px rgba(42, 113, 255, 0.15);\n}\n\n.sl-loc-row-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.sl-loc-pin-wrap {\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  background: #eff6ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.sl-loc-name {\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: #020617;\n  margin: 0 0 2px 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sl-loc-state {\n  font-size: 12px;\n  color: #64748b;\n  margin: 0;\n}\n\n/* ── status badge ────────────────────────────────────────── */\n.sl-status-badge {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  padding: 4px 10px;\n  border-radius: 9999px;\n  flex-shrink: 0;\n}\n\n.sl-status-badge.active { background: #f0fdf4; color: #15803d; }\n.sl-status-badge.ready  { background: #eff6ff; color: #2a71ff; }\n\n/* ── empty states ────────────────────────────────────────── */\n.sl-empty-msg {\n  font-size: 13px;\n  color: #94a3b8;\n  text-align: center;\n  padding: 24px 0;\n  margin: 0;\n}\n\n.sl-loc-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  height: 100%;\n  min-height: 200px;\n  text-align: center;\n  padding: 32px;\n}\n\n.sl-loc-empty-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 20px;\n  background: #f1f5f9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sl-loc-empty-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #334155;\n  margin: 0;\n}\n\n.sl-loc-empty-sub {\n  font-size: 13px;\n  color: #94a3b8;\n  max-width: 280px;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* ── loading ─────────────────────────────────────────────── */\n.sl-loading {\n  display: flex;\n  justify-content: center;\n  padding: 40px 0;\n}\n\n/* ── back btn (kept for safety) ──────────────────────────── */\n.sl-back-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #64748b;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n  flex-shrink: 0;\n}\n\n.sl-back-btn:hover { background: #f8fafc; color: #0f172a; }\n\n/* ── responsive ──────────────────────────────────────────── */\n@media (max-width: 700px) {\n  .sl-page { padding: 0; }\n  .sl-card { border-radius: 0; border: none; }\n  .sl-two-col { flex-direction: column; overflow-y: auto; }\n  .sl-panel-org { width: 100%; flex-shrink: 0; max-height: 45vh; }\n  .sl-panel-loc { flex: none; min-height: 40vh; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
